
import DeviceCard from "./DeviceCard";
import { type Device } from "@/hooks/useDevices";
import { getDeviceStatus } from "@/utils/deviceStatus";

interface DeviceGridProps {
  devices: Device[];
}

const DeviceGrid = ({ devices }: DeviceGridProps) => {
  console.log(`DeviceGrid rendering ${devices.length} devices`);
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {devices.map((device) => {
        console.log(`Rendering device card for ${device.id} - ${device.name}`);
        
        return (
          <DeviceCard 
            key={device.id} 
            device={{
              id: device.id,
              name: device.name,
              os: `${device.os_type} ${device.os_version}`,
              status: getDeviceStatus(device.last_seen || device.created_at, device.status),
              lastSeen: device.last_seen || device.created_at,
              ip: device.ip_address || 'N/A',
              installed_apps: Array.isArray(device.installed_apps) ? device.installed_apps : [],
              battery_level: device.battery_level,
              battery_status: device.battery_status,
              serial_number: device.serial_number,
              department: device.department || 'Unassigned',
              location: device.location || 'Unknown'
            }} 
          />
        );
      })}
    </div>
  );
};

export default DeviceGrid;
